const gpsState = () => useState<GeolocationCoordinates>(() => null);

export function useGPS() {
  const coords = gpsState();

  async function startGeolocationWatch() {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(
        (position) => {
          coords.value = {
            altitude: position.coords.altitude,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          } as GeolocationCoordinates;
        },
        (error) => {
          console.error('Error getting geolocation', error);
        },
      );
    }
  }

  return { coords, startGeolocationWatch };
}
